import angular from "angular";
import { IQuery } from "../../server/query";

export const vsName = "gridSettingsService";

export class GridSettingsService {
  static $inject: string[] = ["$window"];
  private readonly storage: Storage;

  constructor($window: angular.IWindowService) {
    this.storage = $window.localStorage;
  }

  getGridSettings(gridId: symbol): IGridSettings {
    return new GridSettings(gridId, this.storage);
  }
}

export interface IGridSettings {
  syncColumns(columnApi: awk.grid.ColumnApi): void;
  saveState(columnApi: awk.grid.ColumnApi): void;
  getQuery(): IQuery;
  saveQuery(query: IQuery): void;
  getSort(): any;
  saveSort(sort: any): void;
}

export class NullGridSettings implements IGridSettings {
  private _query: IQuery = {};
  private _sort: any = [];

  syncColumns(columnApi: awk.grid.ColumnApi): void {}
  saveState(columnApi: awk.grid.ColumnApi): void {}

  getQuery(): IQuery {
    return this._query;
  }
  saveQuery(query: IQuery): void {
    this._query = query;
  }

  getSort() {
    return this._sort;
  }

  saveSort(sort: any) {
    this._sort = sort;
  }
}

class GridSettings implements IGridSettings {
  private readonly gridId: symbol;
  private readonly storage: Storage;

  constructor(gridId: symbol, storage: Storage) {
    this.gridId = gridId;
    this.storage = storage;
  }

  private getPersistedGridSettings(): IPersistedGridSettings {
    const gsString = this.storage.getItem(this.getStorageKey());
    if (!gsString) {
      return {
        gridState: undefined,
        query: {},
        sort: undefined,
      };
    }
    const result = JSON.parse(gsString);
    return result;
  }

  private persistGridSettings(settings: IPersistedGridSettings): void {
    const gsString = JSON.stringify(settings);
    this.storage.setItem(this.getStorageKey(), gsString);
  }

  private getStorageKey(): string {
    const key = this.gridId.description;

    if (key === undefined) {
      throw new Error("gridId symbol must have description");
    }

    return key;
  }

  syncColumns(columnApi: awk.grid.ColumnApi): void {
    const settings = this.getPersistedGridSettings();
    const gridState = settings.gridState;
    if (gridState) {
      columnApi.setState(gridState);
    }
  }

  saveState(columnApi: awk.grid.ColumnApi): void {
    const settings = this.getPersistedGridSettings();
    settings.gridState = columnApi.getState();
    this.persistGridSettings(settings);
  }

  getQuery(): IQuery {
    const settings = this.getPersistedGridSettings();
    return settings.query;
  }

  saveQuery(query: IQuery): void {
    const settings = this.getPersistedGridSettings();
    settings.query = query;
    this.persistGridSettings(settings);
  }

  getSort(): any {
    const settings = this.getPersistedGridSettings();
    return settings.sort;
  }

  saveSort(sort: any): void {
    const settings = this.getPersistedGridSettings();
    settings.sort = sort;
    this.persistGridSettings(settings);
  }
}

export interface IPersistedGridSettings {
  gridState: any;
  query: IQuery;
  sort: any;
}
